export default {
      id: "Icon--uncommon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--uncommon",
      toString: function () {
        return this.url;
      }
    }